"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { AddToCartButton, EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 6,
  order: "desc",
  orderby: "date"
};
const wp_query = new WP_Query(wp_query_params);
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse rounded-xl bg-muted/10" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Si è verificato un errore durante il caricamento dei prodotti.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Nessun prodotto trovato.</p>
      </div>;
  }
  return <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => {
      const isUsed = product.tags?.some(t => t.name.toLowerCase() === "gebruikt");
      const isOutOfStock = product.tags?.some(t => t.name.toLowerCase() === "uitverkocht");
      return <Card key={product.id} data-index={i} className="group relative flex h-full flex-col overflow-hidden border-border bg-card shadow-lg transition-all duration-300 hover:border-primary/50 hover:shadow-2xl hover:shadow-primary/10">
            {}
            <div className="absolute right-3 top-3 z-10 flex flex-col gap-2">
              {isOutOfStock && <Badge className="border-none bg-destructive text-destructive-foreground shadow-sm font-default">
                  Esaurito
                </Badge>}
              {isUsed && !isOutOfStock && <Badge className="border-none bg-primary text-primary-foreground shadow-sm font-default">
                  Ricondizionato
                </Badge>}
            </div>

            {}
            <div className="flex aspect-square items-center justify-center bg-black p-6">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-secondary text-sm text-muted-foreground font-default">
                  Immagine non disponibile
                </div>}
            </div>

            <CardContent className="flex flex-grow flex-col gap-3 pt-6">
              <Link to={product.link} className="block">
                <h3 className="line-clamp-2 font-default text-xl font-semibold leading-tight text-foreground transition-colors hover:text-primary">
                  {product.title}
                </h3>
              </Link>
              
              <div className="mt-auto pt-4">
                <span className="font-default text-2xl font-bold text-primary">
                  €{product.price?.toFixed(2) || "0.00"}
                </span>
              </div>
            </CardContent>

            <CardFooter className="px-6 pb-6 pt-0">
              <AddToCartButton productId={product.id} className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-default font-medium rounded-full shadow-md transition-all" text="Aggiungi" showQuantity={false} />
            </CardFooter>
          </Card>;
    })}
    </div>;
}
export default function PopulaireProducten() {
  return <section data-section-id="224812" id="i-nostri-prodotti" className="bg-background text-foreground relative py-20 px-4 md:px-8 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, #e40313 1px, transparent 0)',
      backgroundSize: '48px 48px'
    }} />
      
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tighter text-foreground sm:text-4xl md:text-6xl">
            I Nostri Prodotti
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 rounded-lg bg-primary" />
          <p className="mx-auto mt-6 max-w-2xl font-default text-lg text-muted-foreground">
            Sistemi di sicurezza intelligenti progettati per la massima protezione. Tecnologia avanzata, design minimale e affidabilità certificata europea.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date"
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>
        
        <div className="mt-12 text-center md:mt-16">
          <Link to="/ShopPage" className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-border bg-transparent px-8 py-2 text-sm font-medium text-foreground shadow-sm transition-colors hover:bg-primary hover:text-primary-foreground hover:border-primary focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50 font-default">
            Esplora l'intero ecosistema
          </Link>
        </div>
      </div>
    </section>;
}